import { useMutation } from '@apollo/client';
import { Pass } from '../../shared/types';
import { CITRIN_CREATE_PASS, CreatePassRequest, CreatePassResponse } from '..';

type CreateMutationFunction = (request: Pass) => Promise<Pass>;
export const useCreatePassMutation = (): { mutation: CreateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<CreatePassResponse, CreatePassRequest>(CITRIN_CREATE_PASS);
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_createPass;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
